import React from 'react';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import './event-created-at.scss';

interface IEventCreatedAtProps {
  originalEvent: ICalendarEventData;
}

const EventCreatedAt = ({ originalEvent }: IEventCreatedAtProps) => (
  <div className="event-created-at">
    Created: {new Date(originalEvent.createdAt).toLocaleString()}
  </div>
);

export default EventCreatedAt;